import { toast } from "react-toastify";

type Props = {
  message: string;
  type: "success" | "info" | "error" | "warning";
};

const toastUtils = {
  showMessage({ message, type }: Props) {
    switch (type) {
      case "success": {
        toast.success(message, {
          position: "top-right",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        break;
      }

      case "info": {
        toast.info(message, {
          position: "top-right",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        break;
      }

      case "error": {
        toast.error(message, {
          position: "top-right",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        break;
      }

      case "warning": {
        toast.warn(message, {
          position: "top-right",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        break;
      }

      default:
        break;
    }
  },
};

export default toastUtils;
